import { P, SvgIcon } from "@sveabank/cc-common";

type Props = {
	text: string;
};

export const UspListItem = ({ text }: Props) => {
	return (
		<li className="flex items-start gap-2">
			<span className="m-1">
				<SvgIcon height={24} imageSrc="LIST_CHECK" className="text-background-dark" />
			</span>
			<P>{text}</P>
		</li>
	);
};
